<router-outlet></router-outlet> <chat-bot></chat-bot>

@if ((isCookieAccepted$ | async) || isAuthorized) {
  <cookie></cookie>
}
